import script from './SdsSkeleton.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-skeleton"})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5a94e9d1_0", { source: ".sds-skeleton[data-v-5a94e9d1]{position:absolute;inset:0;border-radius:inherit;background:var(--component-skeleton-value-1);background-image:linear-gradient(to right,var(--component-skeleton-value-1) 0,var(--component-skeleton-value-2) 20%,var(--component-skeleton-value-1) 40%,var(--component-skeleton-value-1) 100%);background-repeat:no-repeat;background-size:800% 100%;animation:shimmer-data-v-5a94e9d1 1s infinite forwards linear}@keyframes shimmer-data-v-5a94e9d1{0%{background-position:-100% 0}100%{background-position:100% 0}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5a94e9d1";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
